import styled from 'styled-components'

import { Link } from './style'

import { colors } from 'styles/colors'
import { mobile } from 'styles/responsive'

import Accordion from 'components/Accordion/Accordion'

export const Container = styled.div`
    position: relative;
    padding-bottom: 80px;

    width: 100%;
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;
    text-align: center;

    overflow: hidden;

    > * + * {
        margin-top: 50px;
    }

    /*
    @media (min-width: 1850px) {
        max-width: 1110px;
    }
    */
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;

    max-width: 1110px;
    margin-top: 80px;

    > * + * {
        margin-top: 50px;
    }
`

export const Body = styled.div`
    display: flex;

    flex-direction: column;
    align-items: center;
    position: relative;

    overflow: hidden;
`

export const List = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    margin-bottom: 50px;
    position: relative;
    z-index: 2;

    & > div {
        flex: 1 1 calc(32% - 25px);
        max-width: calc(33% - 25px);
    }

    ${mobile(`
        max-width: 1110px;
        display: flex;
        flex-direction: column;
        margin-bottom: 50px;
        gap: 0;

        & > div {
            flex: 1;
            max-width: 100%;
        }

        & > div .Accordion__desc {
            border-bottom: 2px solid #d7d7d7;
        }
    `)}
`

export const Item = styled.div`
    text-align: left;
    flex: 30%;
    display: flex;
    flex-direction: column;
    margin: 30px 20px 0 0;

    > * + * {
        margin-top: 10px;
    }
`

export const ItemTitle = styled.h4`
    position: relative;
    font-size: 24px;
    font-weight: 700;
    line-height: 30.48px;
    color: ${({ $color }) => $color || colors.deepPurple};
`

export const ItemDesc = styled.span`
    font-size: 16px;
    font-weight: 400;
    line-height: 22.4px;
    color: ${colors.black};
`

export const Background = styled.img`
    position: absolute;
    z-index: -10;

    right: -200px;
    top: -20px;

    width: 1100px;

    ${mobile(`
        top: 80px;
        left: 10px;
        width: 120%;
    `)}
`

export const StyledAccordion = styled(Accordion)`
    .Accordion__title {
        font-size: 16px;
        color: #4d207d;
        text-align: left;
        margin: 0 20px;
    }

    .Accordion__desc {
        margin: 0 20px;

        div {
            color: #505050;
            font-size: 15px;
            padding: 10px 0;
        }
    }
`

export const MobileSpacer = styled.div`
    ${mobile(`
        height: 145px;    
    `)}
`

export const LinkButton = styled(Link)`
    ${mobile(`
        display: flex;
        padding: 0 20px;
        margin-top: 0;
        width: 100%;

        button {
            padding-top: 20px !important;
            padding-bottom: 20px !important;
            flex-grow: 1;
        }    
    `)}
`
